/**
 * Created by Michał Stawski on 24.08.2020.
 */

export const dateFormat = 'YYYY-MM-DD'
export const datetimeFormat = 'YYYY-MM-DD h:mm A'
export const timeFormat = 'h:mm:ss A'
export const defaultDocTitle = 'The Centre'
